import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import Dropdown from "../../common/Dropdown";
import Info from "../../../Images/yellow_info_icon.svg";
import moment from "moment-timezone";
import _ from "lodash";
import { components, useStateManager } from "react-select";
import ToolTip from "../../common/Tooltip";
import Button from "../../common/Button";
import "./SystemSpecification.scss";
import { useDispatch, useSelector } from "react-redux";
import { RegionList } from "../../../redux/TrainingCenter";
import {
  MachineList,
  InstanceList,
} from "../../../redux/features/CreatesessionDropdown";
import { systemSpecification } from "../../../redux/features/CreateSessionReducer";
import { Stack } from "immutable";
import {
  InstructorList,
  StudioList,
} from "../../../redux/features/CreatesessionDropdown";
import { AutoAssign } from "../../../redux/features/CreateSession";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import { API } from "../../../globals/constants";
import MultiLine_Spinner from "../../multiline_spinner/Multiline_spinner";

function SystemSpecification(props) {
  const dispatch = useDispatch();
  const [timeZoneOptions, setTimeZoneOptions] = useState([]);
  const [timezoneSelectedId, setTimeZoneSelectedId] = useState("");
  const [region, setRegion] = useState([]);
  const [regionSelectedId, setRegionSelctedId] = useState("");
  const [instanceType, setInstanceType] = useState([]);
  const [instanceSelectedId, setInstanceSelectedId] = useState("");
  const [machineAmi, setMachineAmi] = useState([]);
  const [machineSelectedId, setMachineSelectedId] = useState("");
  const [sessionDescription, setSessionDescription] = useState("");
  const [error, setError] = useState({
    timezone: false,
    aws_region: false,
    instance: false,
    machine_ami: false,
    training_center: false,
    instructor: false,
  });
  const [selectedOption, setSelectedOption] = useState("studio");
  const [studioList, setStudioList] = useState([]);
  const [studio, setStudio] = useState("");
  const [instructor, setInstructor] = useState([]);
  const [instructorSelectedId, setInstructorSelectedId] = useState("");
  const [loadApi, setLoadApi] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  const instructor_list = useSelector((state) => {
    return state?.instructorData;
  });
  const studio_list = useSelector((state) => {
    return state?.studioList;
  });
  const machine_list = useSelector((state) => {
    return state?.machineList;
  });
  const instance_list = useSelector((state) => {
    console.log("system specification state", state);
    return state?.instanceList;
  });
  const selectedSessionOption = useSelector((state) => {
    console.log("check thr type of cloudp]p]p", state?.CreateSession);
    return state?.CreateSession?.cloudType;
  });
  const region_list = useSelector((state) => {
    return state?.region;
  });
  const create_session = useSelector((state) => {
    return state?.CreateSession;
  });
  const auto_assign = useSelector((state) => {
    return state?.autoAssign;
  });
  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  // const loginData = useSelector((state) => {
  //   return state.login?.loginResponse.data;
  // });
  const handleTimezone = (selected) => {
    setTimeZoneSelectedId(selected);
  };
  const handleAwsRegion = async (selected) => {
    setRegionSelctedId(selected);
    setMachineSelectedId("");
    setInstanceSelectedId("");
    await setMachineAmi([]);
    await setInstanceType([]);
    let machine_param =
      loginData.role_code === "INSTRUCTOR"
        ? {
            is_active: true,
            region_code: selected.value,
            studio_id: loginData.studio_id,
          }
        : loginData.role_code === "STUDIO_ADMIN"
        ? {
            is_active: true,
            region_code: selected.value,
            studio_id: loginData.studio_id,
            created_by: loginData.id,
          }
        : {
            is_active: true,
            region_code: selected.value,
            created_by: loginData.id,
          };
    let instance_param = {
      is_active: true,
      role_id: 3,
      region_code: selected.value,
    };
    await setMachineSelectedId("");
    await setInstanceSelectedId("");
    setIsloading(true);
    dispatch(MachineList({ machine_param }));
    dispatch(InstanceList({ instance_param }));
    await setMachineAmi([]);
    await setInstanceType([]);
  };
  const autoAssign = () => {
    if (auto_assign?.loading === true) {
    } else {
      if (auto_assign?.AutoAssign?.data?.status === 200) {
        let date = auto_assign?.AutoAssign?.data?.data;
        let studio_data = studioList
          ? studioList.filter((item) => item.id === date?.studio_id)
          : "";
        let instructor_data = instructor
          ? instructor.filter((item) => item.id === date?.id)
          : "";
        setStudio(studio_data[0]);
        setInstructorSelectedId(instructor_data[0]);
      } else {
        toast.error("Instructor is not available", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        setSelectedOption("studio");
      }
    }
  };
  useEffect(() => {
    if (selectedOption === "autoassign") {
      autoAssign();
    }
  }, [auto_assign]);
  const toolTipText = (text, project_description, description) => {
    const project = project_description
      ? project_description?.map((item, index) => {
          return `${index + 1}.${item.project_name} \n`;
        })
      : [];

    const tools = text
      ? text?.map((item, index) => {
          console.log("fffff-----", item);
          return `${index + 1}.${item?.tool_name} \n`;
        })
      : [];
    const tooltip = project_description
      ? `Tools: \n ${tools.toString()} \n Project: \n ${project.toString()} \n Description: \n ${description}`
      : `Tools: \n ${text}`;
    return (
      <p style={{ whiteSpace: "pre-line" }} className="line-break">
        {tooltip}
      </p>
    );
  };
  const getMachineList = () => {
    console.log("machine_list", machine_list);
    if (machine_list.loading === true) {
    } else {
      setIsloading(false);
      let data = machine_list?.machineData?.data?.data;
      let machine_data = data?.map((item) => {
        let temp = {
          id: item.ami.id,
          value: item.ami.ami_id,
          label: item.ami.name,
          description: toolTipText(
            item.tools,
            item.project,
            item.ami.discription
          ),
        };
        return temp;
      });
      if (create_session?.systemSpecification) {
        let machine = machine_data
          ? machine_data.filter(
              (item) =>
                item?.value ===
                create_session?.systemSpecification?.machine_ami_id
            )
          : "";
        setMachineSelectedId(machine[0]);
      }
      setMachineAmi(machine_data?.length > 0 ? [...machine_data] : []);
    }
  };
  const getInstanceList = () => {
    if (instance_list.loading === true) {
    } else {
      setIsloading(false);
      let data = instance_list?.instanceData?.data?.data;
      let instance_data = data?.map((item) => {
        let temp = {
          id: item.id,
          value: item.instance,
          label: item.instance,
          description: item.description,
        };
        return temp;
      });
      if (create_session?.systemSpecification) {
        let instance = instance_data
          ? instance_data?.filter(
              (item) =>
                item?.id === create_session?.systemSpecification?.instance_id
            )
          : "";
        setInstanceSelectedId(instance[0]);
      }
      setInstanceType(instance_data?.length > 0 ? [...instance_data] : []);
    }
  };
  const getStudioList = async () => {
    if (studio_list?.loading === true) {
    } else {
      let data = studio_list?.studioData?.data?.data?.rows;
      let data_studio = data?.map((item) => {
        let temp = {
          id: item.id,
          value: item.studio_name,
          label: `${item.studio_name}`,
        };
        return temp;
      });
      if (
        create_session?.systemSpecification ||
        loginData.role_code === "STUDIO_ADMIN"
      ) {
        if (loginData.role_code === "STUDIO_ADMIN") {
          setStudio(data_studio[0]);
          let params = {
            is_active: true,
            role_id: 3,
            studio_id: loginData.studio_id,
          };
          let endPoints =
            loginData.role_code === "STUDIO_ADMIN"
              ? API.END_POINTS.STUD_ADMIN
              : API.END_POINTS.USERS;
          await dispatch(InstructorList({ params, endPoints }));
        } else {
          let studio_data = data_studio
            ? data_studio.filter(
                (item) =>
                  item.id === create_session?.systemSpecification?.studio_id
              )
            : "";
          console.log("studio_data", studio_data, data_studio[0]);
          setStudio(studio_data[0]);
        }
      }
      await setStudioList([...data_studio]);
    }
  };
  const handleInstance = (selected) => {
    setInstanceSelectedId(selected);
  };
  const handleInstructor = (selected) => {
    setInstructorSelectedId(selected);
  };
  const handleChange = async (selected) => {
    setStudio(selected);
    let params = {
      is_active: true,
      role_id: 3,
      studio_id: selected.id,
    };
    console.log("paramsofinstructor", {
      is_active: true,
      role_id: 3,
      selected,
    });
    setInstructorSelectedId("");
    setIsloading(true);
    let endPoints =
      loginData.role_code === "STUDIO_ADMIN"
        ? API.END_POINTS.STUD_ADMIN
        : API.END_POINTS.USERS;
    await dispatch(InstructorList({ params, endPoints }));
  };
  const getInstructorData = async () => {
    if (instructor_list?.loading === true) {
    } else {
      setIsloading(false);
      let data = instructor_list?.InstructorData?.data?.data?.rows;
      let data_instructor = data?.map((item) => {
        let temp = {
          id: item.id,
          value: item.name,
          label: item.name,
        };

        return temp;
      });
      if (create_session?.systemSpecification?.instructor_id) {
        let instructor = data_instructor
          ? data_instructor.filter(
              (item) =>
                item.id === create_session?.systemSpecification?.instructor_id
            )
          : "";
        setInstructorSelectedId(instructor[0]);
      }
      await setInstructor([...data_instructor]);
    }
  };
  const handleMachineAmi = (selected) => {
    setMachineSelectedId(selected);
  };

  const isValid = () => {
    let error = false;
    if (loginData.role_code === "SUPER_ADMIN") {
      if (
        timezoneSelectedId !== "" &&
        regionSelectedId !== "" &&
        instanceSelectedId !== "" &&
        machineSelectedId !== "" &&
        instructorSelectedId !== "" &&
        studio !== ""
      ) {
        return false;
      } else {
        return true;
      }
    } else if (loginData.role_code === "STUDIO_ADMIN") {
      if (
        timezoneSelectedId !== "" &&
        regionSelectedId !== "" &&
        instanceSelectedId !== "" &&
        machineSelectedId !== "" &&
        instructorSelectedId !== ""
      ) {
        return false;
      } else {
        return true;
      }
    } else if (loginData.role_code === "INSTRUCTOR") {
      if (
        timezoneSelectedId !== "" &&
        regionSelectedId !== "" &&
        instanceSelectedId !== "" &&
        machineSelectedId !== "" &&
        timezoneSelectedId !== undefined &&
        regionSelectedId !== undefined &&
        instanceSelectedId !== undefined &&
        machineSelectedId !== undefined
      ) {
        return false;
      } else {
        return true;
      }
    }
  };
  const handleAutoAssign = (event) => {
    setSelectedOption(event.target.value);
    if (event.target.value === "autoassign") {
      let bodyParam = {
        session_start_date:
          create_session?.scheduleTraining?.session_start_date,
        session_end_date: create_session?.scheduleTraining?.session_end_date,
        tags: create_session?.sessionDetails?.tags
          ? [...JSON.parse(create_session?.sessionDetails?.tags)]
          : [],
        title: create_session?.sessionDetails?.title,
        zone: timezoneSelectedId.value,
      };
      dispatch(AutoAssign({ bodyParam }));
      let params = {
        is_active: true,
        role_id: 3,
        // studio_id: selected.id,
      };
      let endPoints =
        loginData.role_code === "STUDIO_ADMIN"
          ? API.END_POINTS.STUD_ADMIN
          : API.END_POINTS.USERS;
      dispatch(InstructorList({ params, endPoints }));
    }
  };
  const onContinue = () => {
    console.log("nbvvvvvvvvvvvvvvvvvvvn", isValid());
    if (!isValid()) {
      dispatch(
        systemSpecification(
          loginData.role_code === "STUDIO_ADMIN"
            ? {
                zone: timezoneSelectedId.value,
                region_code: regionSelectedId.value,
                machine_ami_id: machineSelectedId.value,
                instance_id: instanceSelectedId.id,
                instructor_id: instructorSelectedId.id,
              }
            : loginData.role_code === "INSTRUCTOR"
            ? {
                zone: timezoneSelectedId.value,
                region_code: regionSelectedId.value,
                machine_ami_id: machineSelectedId.value,
                instance_id: instanceSelectedId.id,
              }
            : {
                zone: timezoneSelectedId.value,
                region_code: regionSelectedId.value,
                machine_ami_id: machineSelectedId.value,
                instance_id: instanceSelectedId.id,
                instructor_id: instructorSelectedId.id,
                studio_id: studio.id,
              }
        )
      );
      props.handleNext();
    } else {
      setError({
        timezone:
          timezoneSelectedId === "" || timezoneSelectedId === undefined
            ? true
            : false,
        aws_region:
          regionSelectedId === "" || regionSelectedId === undefined
            ? true
            : false,
        instance:
          instanceSelectedId === "" || instanceSelectedId === undefined
            ? true
            : false,
        machine_ami:
          machineSelectedId === "" || machineSelectedId === undefined
            ? true
            : false,
        training_center: studio === "" || studio === undefined ? true : false,
        instructor:
          loginData.role_code === "INSTRUCTOR"
            ? ""
            : instructorSelectedId === "" || instructorSelectedId === undefined
            ? true
            : false,
      });
    }
  };
  const getsortedData = async (data) => {
    const posArr = data.filter((num) => num["timeslip"] > -1);
    const positivesort = _.orderBy(posArr, ["time"], ["asc"]);
    const negArr = data.filter((num) => num["timeslip"] < -1);
    const negativesort = _.orderBy(negArr, ["time"], ["desc"]);
    return [...negativesort, ...positivesort];
  };
  const renderStudioSelect = () => {
    return (
      <div
        className={
          selectedOption === "studio"
            ? "classMargin"
            : "classPadding classMargin opacity_change"
        }
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="h6" className="AutoAssignFieldHeading">
                Training Center
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Dropdown
                placeholder="Select training center"
                options={studioList}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) => handleChange(selected)}
                allowSelectAll={true}
                value={studio}
                isDisabled={selectedOption === "autoassign"}
              />
              {selectedOption === "studio" && error.training_center && (
                <small className="error small_f">
                  Please Select Training Center *
                </small>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mt: 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="h6" className="AutoAssignFieldHeading">
                Instructor
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Dropdown
                placeholder="Select instructor"
                options={instructor}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={handleInstructor}
                allowSelectAll={true}
                value={instructorSelectedId ? instructorSelectedId : ""}
                isDisabled={selectedOption === "autoassign"}
              />
              {selectedOption === "studio" && error.instructor && (
                <small className="error small_f">
                  Please Select Instructor *
                </small>
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };
  const renderAutoassignSelect = () => {
    if (selectedOption === "studio") {
      return (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="padding_top"
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={2} md={2} lg={4} xl={4}>
              <Typography
                variant="h6"
                className="FieldHeading AutoAssignHeading"
              >
                Auto Assign
              </Typography>
            </Grid>
            <Grid item xs={10} sm={8} md={10} lg={8} xl={8}>
              <Typography variant="h6" className="AutoAssignPara FieldHeading">
                Instructor will be auto assign to a particular session
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <div className="classMargin">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h6" className="AutoAssignFieldHeading">
                  Training Center
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Dropdown
                  placeholder="Select training center"
                  options={studioList}
                  isMulti={false}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected) => handleChange(selected)}
                  allowSelectAll={true}
                  value={studio}
                />
                {selectedOption === "autoassign" && error.training_center && (
                  <small className="error small_f">
                    Please Select Training Center *
                  </small>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mt: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h6" className="AutoAssignFieldHeading">
                  Instructor
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Dropdown
                  placeholder="Select instructor"
                  options={instructor}
                  isMulti={false}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={handleInstructor}
                  allowSelectAll={true}
                  value={instructorSelectedId}
                />
                {selectedOption === "autoassign" && error.instructor && (
                  <small className="error small_f">
                    Please Select Instructor*
                  </small>
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    }
  };
  const loadTimeZone = async () => {
    let timeZones = [];
    timeZones = moment.tz.names();
    var offsetTmz = [];
    if (timeZones) {
      for (var i in timeZones) {
        let each_timezone = {};
        each_timezone = {
          value: timeZones[i],
          label:
            timeZones[i] + //split here based on $ to get timezone
            `-${moment.tz(timeZones[i]).format("z")} (GMT ${moment
              .tz(timeZones[i])
              .format("Z")})`,
          id:
            timeZones[i] +
            `-${moment.tz(timeZones[i]).format("z")} (GMT ${moment
              .tz(timeZones[i])
              .format("Z")})`,
          name:
            timeZones[i] +
            `-${moment.tz(timeZones[i]).format("z")} (GMT ${moment
              .tz(timeZones[i])
              .format("Z")})`,
          text:
            `(GMT ${moment.tz(timeZones[i]).format("Z")}) ` +
            timeZones[i] +
            `-${moment.tz(timeZones[i]).format("z")} `,
          time: moment.tz(timeZones[i]).format("Z"), /// added for filtering only
          timeslip: +moment.tz(timeZones[i]).format("Z").split(":")[0], /// added for filtering only

          gmt: `${timeZones[i]} (UTC ${moment.tz(timeZones[i]).format("Z")})`,
        };
        offsetTmz.push(each_timezone);
      }
    }
    let sortedData = await getsortedData(offsetTmz);
    if (create_session?.systemSpecification) {
      let timezone = sortedData.filter(
        (item) => item.value === create_session?.systemSpecification?.zone
      );
      setTimeZoneSelectedId(timezone[0]);
    }
    setTimeZoneOptions(sortedData);
  };
  const getRegion = () => {
    if (region_list?.loading === true) {
    } else {
      let data = region_list?.regionData?.data?.data?.rows;
      let region_data = data?.map((item) => {
        let temp = {
          id: item.id,
          value: item?.code,
          label: item?.region_name,
        };
        return temp;
      });
      if (region_data) {
        if (create_session?.systemSpecification) {
          let region = region_data.filter(
            (item) =>
              item.value === create_session?.systemSpecification?.region_code
          );
          setRegionSelctedId(region[0]);
        }
      }

      setRegion(region_data?.length > 0 ? [...region_data] : []);
    }
  };
  const Option = (props) => {
    console.log("machine_list", props);
    return (
      <div>
        <components.Option {...props}>
          <ToolTip
            title={props.data.description}
            placement="right"
            arrow={true}
            content={props.label}
          ></ToolTip>
        </components.Option>
      </div>
    );
  };
  useEffect(() => {
    getMachineList();
  }, [machine_list?.machineData]);
  useEffect(() => {
    getInstanceList();
  }, [instance_list?.instanceData]);
  useEffect(
    () => {
      if (!create_session?.systemSpecification || props.action === "copy") {
        // let machine_param = {
        //   is_active: true,
        //   region_code: create_session?.systemSpecification?.region_code,
        //   created_by: loginData.id,
        // };
        let machine_param =
          loginData.role_code === "INSTRUCTOR"
            ? {
                is_active: true,
                region_code: create_session?.systemSpecification?.region_code,
                studio_id: loginData.studio_id,
              }
            : loginData.role_code === "STUDIO_ADMIN"
            ? {
                is_active: true,
                region_code: create_session?.systemSpecification?.region_code,
                studio_id: loginData.studio_id,
                created_by: loginData.id,
              }
            : {
                is_active: true,
                region_code: create_session?.systemSpecification?.region_code,
                created_by: loginData.id,
              };
        let instance_param = {
          is_active: true,
          role_id: 3,
          region_code: create_session?.systemSpecification?.region_code,
        };
        console.log("check api----");
        dispatch(MachineList({ machine_param }));
        dispatch(InstanceList({ instance_param }));
        let params = {
          is_active: true,
          role_id: 3,
          studio_id: create_session?.systemSpecification?.studio_id,
        };
        let endPoints =
          loginData.role_code === "STUDIO_ADMIN"
            ? API.END_POINTS.STUD_ADMIN
            : API.END_POINTS.USERS;
        if (loginData.role_code === "INSTRUCTOR") {
        } else {
          dispatch(InstructorList({ params, endPoints }));
        }
      }
    },
    [create_session],
    [studio]
  );
  useEffect(() => {
    getRegion();
  }, [region_list?.regionData]);
  useEffect(() => {
    getStudioList();
  }, [studio_list]);
  useEffect(() => {
    getInstructorData();
  }, [instructor_list?.InstructorData]);
  useEffect(() => {}, [region], [studioList], [instructor]);
  useEffect(() => {
    loadTimeZone();

    let params = {
      is_active: true,
      // cloud_type: "AWS",
      cloud_type:
        selectedSessionOption?.sessionType === "longtermsession"
          ? "GCP"
          : "AWS",
    };
    let studio_param =
      loginData.role_code === "STUDIO_ADMIN"
        ? {
            is_active: true,
            studio_id: loginData.studio_id,
          }
        : {
            is_active: true,
          };
    dispatch(RegionList({ params }));
    if (loginData.role_code === "INSTRUCTOR") {
    } else {
      dispatch(StudioList({ studio_param }));
    }

    if (regionSelectedId === "") {
      return setInstanceType([]), setMachineAmi([]);
    }
    if (studio === "") {
      setInstructor([]);
    }
  }, []);
  useEffect(() => {}, [machineSelectedId, instanceSelectedId]);
  useEffect(() => {}, [regionSelectedId]);
  useEffect(() => {
    setInstructor([]);
  }, [!studio]);
  return (
    <>
      <Grid container rowSpacing={1} columnSpacing={2}>
        {console.log(
          "test999999",
          machineAmi,
          machineSelectedId,
          instanceType,
          instanceSelectedId
        )}
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Timezone
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <Dropdown
                placeholder="Select timezone"
                options={timeZoneOptions}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={handleTimezone}
                allowSelectAll={true}
                value={timezoneSelectedId}
              />
              {error.timezone && (
                <small className="error small_f">
                  Please Select Timezone *
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "This is the timezone in which your class will take place"
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Region
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <Dropdown
                placeholder="Select region"
                options={region}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={handleAwsRegion}
                allowSelectAll={true}
                value={regionSelectedId}
              />
              {error.aws_region && (
                <small className="error small_f">
                  Please Select Aws Region *
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "Select the nearest region with respect to your training location. This is only for self-reference and tagging purposes."
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Instance Type
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <Dropdown
                placeholder="Select instance"
                options={instanceType}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={handleInstance}
                allowSelectAll={true}
                components={{
                  Option,
                }}
                value={instanceSelectedId ? instanceSelectedId : ""}
              />
              {error.instance && (
                <small className="error small_f">
                  Please select instance type *
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "Instance types refer to the configuration of the hardware provided in the VM. For an introduction class you can select a low end config while for an advanced class such as animation sessions, select a high end config. Hover your mouse on the list items to get more details of the instance types. If you are unsure, contact support."
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <Typography variant="h6" className="FieldHeading">
                Machine Image
              </Typography>
            </Grid>
            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
              <Dropdown
                placeholder="Select AMI"
                options={machineAmi}
                isMulti={false}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={handleMachineAmi}
                allowSelectAll={true}
                components={{
                  Option,
                }}
                value={machineSelectedId ? machineSelectedId : ""}
              />
              {error.machine_ami && (
                <small className="error small_f">
                  Please Select Machine Ami*
                </small>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <div className="infostyle">
                <ToolTip
                  title={
                    "Machine image contains the tools and the projects you need to teach this class. Hover your mouse to get more info on the images. You can create custom images using the Image Configurator portal on the top."
                  }
                  placement="right"
                  arrow={true}
                  content={<img src={Info} />}
                ></ToolTip>
              </div>
            </Grid>
          </Grid>
        </Grid>
        {loginData?.role_code === "INSTRUCTOR" ? (
          <Grid container className="assig_btn"></Grid>
        ) : loginData?.role_code === "STUDIO_ADMIN" ? (
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Grid container spacing={1}>
              <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                <Typography variant="h6" className="FieldHeading">
                  Instructor
                </Typography>
              </Grid>
              <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                <Dropdown
                  placeholder="Select instructor"
                  options={instructor}
                  isMulti={false}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={handleInstructor}
                  allowSelectAll={true}
                  value={instructorSelectedId}
                />
                {selectedOption === "studio" && error.instructor && (
                  <small className="error small_f">
                    Please Select Instructor *
                  </small>
                )}
              </Grid>
            </Grid>
            <Grid container className="assig_btn"></Grid>
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="assignedbtm">
              <Grid container>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      lg={1}
                      xl={1}
                      className="assign_padding"
                    >
                      <label>
                        <input
                          type="radio"
                          value="studio"
                          onChange={(e) => handleAutoAssign(e)}
                          checked={selectedOption === "studio" ? true : false}
                        />
                      </label>
                    </Grid>
                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                      {renderStudioSelect()}
                    </Grid>
                  </Grid>
                </Grid>
                {loginData.role_code === "STUDIO_ADMIN" ||
                  loginData.role_code === ""}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      lg={1}
                      xl={1}
                      className="assign_padding"
                    >
                      <label>
                        <input
                          type="radio"
                          value="autoassign"
                          onChange={(e) => handleAutoAssign(e)}
                          checked={
                            selectedOption === "autoassign" ? true : false
                          }
                        />
                      </label>
                    </Grid>
                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                      {renderAutoassignSelect()}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        )}
      </Grid>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flexClass align-btn">
            <Grid item xs={6} sm={6} md={3} lg={2} xl={2}>
              <Button
                value="Previous"
                onClick={props.handleBack}
                role="default"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={2} xl={2}>
              <Button
                value="Continue"
                onClick={() => onContinue()}
                role="primary"
              />
            </Grid>
          </div>
        </Grid>
      </Grid>
      {isLoading && <MultiLine_Spinner />}
    </>
  );
}

export default SystemSpecification;
